module.exports = __webpack_public_path__ + "img/coins-swap-02.40f1469e.svg";